var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"column-chart"},[_c('div',{staticClass:"contant-chart"},[_c('div',{staticClass:"title-chart"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"decor-chart"}),_c('div',{class:`body-chart chart-height_${_vm.num}`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }